import VueCookies from 'vue-cookies'

/** 서버는 `Bearer <jwt>` 또는 순수 JWT 모두 허용. axios에는 Bearer 형태로 통일. */
function toBearer(token) {
	if (token == null || token === '') return null
	const t = String(token).trim()
	if (!t) return null
	return t.startsWith('Bearer ') ? t : `Bearer ${t}`
}

class User {
	constructor(instance) {
		this.axios = instance
	}
	async initToken() {
		try {
			const raw = VueCookies.get('token')
			if (raw == null || raw === '') return
			const token =
				typeof raw === 'string' ? JSON.parse(raw) : raw
			const bearer = toBearer(token)
			if (bearer) {
				this.axios.defaults.headers.common['Authorization'] = bearer
			}
		} catch (e) {
			// 쿠키 없음/손상 시 로그인 페이지 등에서 앱이 죽지 않도록 무시
			delete this.axios.defaults.headers.common['Authorization']
		}
	}
	async logout() {
		VueCookies.remove('token')
		delete this.axios.defaults.headers.common['Authorization']
		location.href = '/'
	}
	//로그인
	async login(params) {
		if (params.keepLogin) {
			VueCookies.set('signin', JSON.stringify(params))
		}
		const response = await this.axios.post(`/user/signin`, params)
		if (response.data.token) {
			VueCookies.set('token', JSON.stringify(response.data.token))
			const bearer = toBearer(response.data.token)
			if (bearer) {
				this.axios.defaults.headers.common['Authorization'] = bearer
			}
		}
		return response
	}
	//로그인 상태 유지 시 자동 로그인
	async autoLogin() {
		const signin = VueCookies.get('signin')
		const result = JSON.parse(JSON.stringify(signin))
		if (result?.id) {
			return result
		} else {
			return false
		}
	}
	//비밀번호 변경하기
	async editPassword(payload) {
		const res = await this.axios.patch(`/user/password`, {
			newPassword: payload.newPassword
		})
		return res
	}
	//본인 프로필 수정 (직위 · ADMIN은 이름·이메일·소속·권한)
	async editProfile(payload) {
		const response = await this.axios.patch(`/user/profile`, payload)
		return response.data
	}
	async updateSignature(file) {
		const data = new FormData()
		data.append('file', file)
		const response = await this.axios.put('/user/signature', data, {
			headers: { 'Content-Type': 'multipart/form-data' }
		})
		return response.data
	}
	//현재 로그인 사용자의 시험항목별 유효 권한 맵
	async getTestPermissions() {
		const response = await this.axios.get(`/user/test-permissions`)
		return response.data
	}
	//현재 로그인 사용자의 역할 기반 권한(페이지/기능/상태전이) + 캐시 버전
	async getPermissions() {
		const response = await this.axios.get(`/user/permissions`)
		return response.data
	}
	//권한 캐시 버전만 경량 조회
	async getPermissionVersion() {
		const response = await this.axios.get(`/user/permissions/version`)
		return response.data?.version
	}
	//유저 프로필
	async getProfile() {
		const response = await this.axios.get(`/user/profile`)
		const deptId = response.data.dept_id || ''
		if (deptId.includes('토양')) {
			response.data.category = 'SOIL'
		} else if (deptId.includes('수질')) {
			response.data.category = 'WATER'
		} else if (deptId.includes('대기')) {
			response.data.category = 'AIR'
		} else if (deptId.includes('폐기물')) {
			response.data.category = 'DISPOSAL'
		}
		return response.data
	}
	async getUserTechList() {
		const response = await this.axios.get(`/user/tech/name/list`)

		return response.data.list
	}
	async getUserNameList(field, value) {
		const response = await this.axios.get(`/user/simple/name/list`, {
			params: {
				field,
				value
			}
		})

		return response.data.list
	}
	//유저 사인 정보 가져오기
	async getUserSignImg(id, version) {
		const response = await this.axios.get(`/user/${id}/signature`, {
			responseType: 'blob',
			params: version ? { v: version } : { _: Date.now() }
		})
		return response
	}
	//시험성적서 담당자 정보 가져오기 - sampleCollector, master, researcher
	async getTestUserInfo(id, key) {
		const response = await this.axios.get(`/project/${id}/user/${key}`)
		return response.data
	}
	//시험자 정보 가져오기
	async getResearcherInfo(type) {
		const response = await this.axios.get(`/user/${type}/researcher`)
		return response.data
	}
	//시험 책임자 정보 가져오기
	async getMasterInfo(type) {
		const response = await this.axios.get(`/user/${type}/master`)
		return response.data
	}
}

export default User
